<mat-toolbar mat-dialog-title data-testid="confirm-delete-dialog-title">
  {{ 'confirm_delete_tr' | translate }}
</mat-toolbar>

<mat-dialog-content style="padding: 1em 1em">
  {{ 'continue_delete_tr' | translate }} {{ data.type }}
  <strong>{{ data.name }}</strong>
  ?
</mat-dialog-content>

<dialog-form-actions>
  <button type="button" data-testid="confirm-delete-action" [mat-dialog-close]="true" color="warn" mat-raised-button>
    {{ 'Delete_tr' | translate }}
  </button>
  <button type="button" data-testid="cancel-delete-action" [mat-dialog-close]="false" mat-raised-button>
    {{ 'cancel_tr' | translate }}
  </button>
</dialog-form-actions>
